import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    selectAll: translate({ id: 'components.schedulerHeader.selectAll' }),
    unselectAll: translate({ id: 'components.schedulerHeader.unselectAll' }),
  }))

  return api
}
